<div *ngIf="!($showResults | async)">
  <div class="row mt-5">
    <div class="col-4 offset-4">
      <mat-form-field appearance="outline" class="mat-input-no-message filter-text-field w-100" id="order-id-field" #orderIdField>
        <mat-label>Work Order ID</mat-label>
        <mat-icon matPrefix class="search-prefix text-muted">search</mat-icon>
        <input matInput type="text" [(ngModel)]="orderIdText" (keyup.enter)="onOrderChange()" #orderIdInput />
      </mat-form-field>
    </div>
  </div>
  <div class="row">
    <div class="col-4 offset-4">
      <mat-form-field appearance="outline" class="mat-input-no-message filter-text-field w-100" #supplierNameField>
        <mat-label>Supplier Name</mat-label>
        <mat-icon matPrefix class="search-prefix text-muted">search</mat-icon>
        <input matInput type="text" [(ngModel)]="supplierNameText" (keyup.enter)="onOrderChange()" #supplierNameInput />
      </mat-form-field>
    </div>
  </div>
  <div class="row">
    <div class="col-4 offset-4 text-center">
      <button
          (click)="onOrderChange()"
          mat-flat-button
          [class.bg-primary]="!loading"
          [class.text-white]="!loading"
          class="button-text w-50 p-2 mt-2"
          [disabled]="!orderIdText && !supplierNameText"
        >
          Search
      </button>
    </div>
  </div>
</div>

<div [hidden]="!($showResults | async)" class="position-relative rounded" style="
  overflow: hidden;
  overflow-y: scroll;
  height: 90vh;
  display: flex;
  flex-direction: column;
">
  <mat-progress-bar class="w-100 progress-bar" style="position: absolute; top: 0; z-index: 999;" [class.progress-bar-hidden]="!loading" mode="indeterminate"></mat-progress-bar>
  <div id="filter-bar">
    <mat-form-field appearance="outline" class="mat-input-no-message dense-field" id="search-field" #searchField>
      <mat-label>Text filter</mat-label>
      <mat-icon matPrefix class="text-muted">search</mat-icon>
      <input matInput type="text" [(ngModel)]="searchText" (keyup.enter)="onSearchChange()" #searchInput />
    </mat-form-field>
    <mat-form-field appearance="outline" class="mat-input-no-message" id="daterange-field" #rangeField>
      <mat-label>Date Range</mat-label>
      <mat-date-range-input [rangePicker]="picker">
        <input matStartDate [(ngModel)]="since" (keyup.enter)="onSearchChange()" placeholder="Start date">
        <input matEndDate [(ngModel)]="until" (keyup.enter)="onSearchChange()" placeholder="End date">
      </mat-date-range-input>
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>
    <button
      (click)="onSearchChange()"
      mat-flat-button
      [class.bg-primary]="!loading"
      [class.text-white]="!loading"
      class="button-text"
      [disabled]="loading"
    >
      Apply
    </button>
    <button
      mat-flat-button
      (click)="clearSearch()"
      [class.bg-primary]="!loading"
      [class.text-white]="!loading"
      class="button-text"
      [disabled]="loading || (searchText === '' && since === null && until === null)"
    >
      Clear
    </button>
    <button
      mat-flat-button
      [class.bg-primary]="!loading"
      [class.text-white]="!loading"
      [disabled]="loading"
      class="button-text"
      (click)="resetResults()"
    >
      New
    </button>
    <button
      mat-flat-button
      [class.bg-primary]="!loading"
      [class.text-white]="!loading"
      [disabled]="loading"
      class="button-text"
      (click)="export()"
    >
      Export
    </button>
  </div>

  <div id="aggregate-total">
    Total: {{ $filteredSum | async | currency }}
  </div>

  <mat-table
    #dataTable
    [dataSource]="dataSource"
    matSort
    class="w-100 flex-grow-1"
    [class.loading]="loading"
  >
    <mat-header-row *matHeaderRowDef="rowDisplayedColumns"></mat-header-row>

    <mat-row
      *matRowDef="let row; columns: rowDisplayedColumns;"
      [routerLink]="'/purchasing/order/' + row.purchaseOrderId"
      class="oor-row oospr-data-row"
    ></mat-row>

    <div class="mat-row" *matNoDataRow>
      <div class="mat-cell"
        [attr.colspan]="rowDisplayedColumns.length"
        class="text-muted small font-italic text-center"
        *ngIf="!loading"
      >
        No results. Click "CLEAR" to remove filters, or "NEW" to search again.
      </div>
    </div>

    <ng-container matColumnDef="datePlaced">
      <mat-header-cell *matHeaderCellDef style="flex-basis: 5%"> Date Placed </mat-header-cell>
      <mat-cell *matCellDef="let row" style="flex-basis: 5%">
        {{ row.datePlaced | date:'dd-MMM-yy' }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="name">
      <mat-header-cell *matHeaderCellDef style="flex-basis: 30%"> Name </mat-header-cell>
      <mat-cell *matCellDef="let row" style="flex-basis: 30%">
        {{ row.name }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="vendor">
      <mat-header-cell *matHeaderCellDef style="flex-basis: 10%"> Vendor </mat-header-cell>
      <mat-cell *matCellDef="let row" style="flex-basis: 10%">
        {{ row.vendor }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="totalCost">
      <mat-header-cell *matHeaderCellDef style="flex-basis: 10%; padding-left: 1em;"> Total Cost </mat-header-cell>
      <mat-cell *matCellDef="let row" style="flex-basis: 10%; padding-left: 1em;">
        {{ row.totalCost | currency }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="purchaseOrderNumber">
      <mat-header-cell *matHeaderCellDef style="flex-basis: 5%"> PO # </mat-header-cell>
      <mat-cell *matCellDef="let row" style="flex-basis: 5%">
        {{ row.purchaseOrderNumber }}
      </mat-cell>
    </ng-container>

  </mat-table>

  <mat-paginator
    [pageSizeOptions]="[15]"
    showFirstLastButtons
    aria-label="Select page of periodic elements"
    style="position: sticky; bottom: -1px;"
  ></mat-paginator>
</div>